import { render, staticRenderFns } from "./entrustLawyer.vue?vue&type=template&id=469d85a4&scoped=true&"
import script from "./entrustLawyer.vue?vue&type=script&lang=js&"
export * from "./entrustLawyer.vue?vue&type=script&lang=js&"
import style0 from "./entrustLawyer.vue?vue&type=style&index=0&id=469d85a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469d85a4",
  null
  
)

export default component.exports